import { ApplicationsStore } from "@/services/stores/types";

export const selectApplicationStore = ({
  applications,
  activeApplication,
  setApplications,
  setActiveApplication,
  resetApplications,
}: ApplicationsStore) => ({
  applications,
  activeApplication,
  setApplications,
  setActiveApplication,
  resetApplications,
});

export const selectApplicationsData = ({
  applications,
}: ApplicationsStore) => ({
  applications,
});

export const selectActiveApplicationData = ({
  activeApplication,
}: ApplicationsStore) => ({
  activeApplication,
});
